import React, { Fragment, MouseEvent, useState } from 'react';
import {
  Avatar,
  Badge,
  Box,
  CardContent,
  CardHeader,
  CustomTheme,
  IconButton,
  useTheme,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MessageCard } from '../MessageCard';
import { ContextMenu, ContextMenuOption } from '@components/context-menu';
import FlagIcon from '@mui/icons-material/Flag';
import { useTranslation } from 'react-i18next';
import { IActivityPost } from './interfaces';
import { useRelativeTime } from '@context/TimeContext';
import { formatRelativeTime } from '@helpers/formatRelativeTimeHelper';

export const ActivityPost: React.FC<IActivityPost> = ({
  date,
  title,
  badgeIcon: BadgeIcon,
  icon: Icon,
  children,
  onClick,
}): JSX.Element => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const now = useRelativeTime();
  const relativeDate = formatRelativeTime(now, date);
  const theme = useTheme<CustomTheme>();

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const avatar = (
    <Avatar sx={{ backgroundColor: 'secondary.main' }}>
      <Icon />
    </Avatar>
  );

  return (
    <Box onClick={onClick}>
      <MessageCard
        sx={{
          pb: children ? undefined : '16px',
          ...(onClick && {
            '@media (hover: hover) and (pointer: fine)': {
              '&:hover': {
                backgroundColor: theme.palette.grey[100],
                cursor: 'pointer',
              },
            },
          }),
        }}
      >
        <CardHeader
          avatar={
            BadgeIcon ? (
              <Badge
                overlap="circular"
                color="light"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                  <BadgeIcon
                    sx={{
                      width: '14px',
                      height: '14px',
                    }}
                  />
                }
              >
                {avatar}
              </Badge>
            ) : (
              avatar
            )
          }
          action={
            <Fragment>
              <IconButton
                aria-label="settings"
                size="small"
                onClick={handleMenuOpen}
              >
                <MoreVertIcon
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconButton>
              <ContextMenu
                anchorEl={anchorEl}
                open={anchorEl !== null}
                onClose={handleMenuClose}
              >
                <ContextMenuOption
                  onClick={() => console.log('report message')}
                  label={t('feed:buttons.reportMessage')}
                  icon={FlagIcon}
                />
              </ContextMenu>
            </Fragment>
          }
          title={title}
          subheader={relativeDate}
          sx={{
            pb: 0,
          }}
        />
        {children && <CardContent>{children}</CardContent>}
      </MessageCard>
    </Box>
  );
};
